/**
 * System Monitoring Dashboard - Router-based Navigation
 * AWS CloudWatch, Website Status, ECS Monitoring, and System Monitoring with React Router nested routes
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AWSMonitor from './AWSMonitor';
import WebsiteMonitor from './WebsiteMonitor';
import ApiHealthMonitor from './ApiHealthMonitor';
import ECSMonitor from './ECSMonitor';

/**
 * SystemMonitoring Component - Router-based navigation
 * Maps URL paths to specific monitoring components
 */
const SystemMonitoring: React.FC = () => {
  return (
    <Routes>
      {/* AWS Monitor — integrated dashboard with CloudWatch logs at bottom */}
      <Route path="aws" element={<AWSMonitor />} />

      {/* Website Status Monitoring */}
      <Route path="website" element={<WebsiteMonitor />} />

      {/* API Health Monitoring */}
      <Route path="api" element={<ApiHealthMonitor />} />

      {/* ECS Container Monitoring */}
      <Route path="ecs" element={<ECSMonitor />} />

      {/* Default redirect to AWS monitor */}
      <Route path="/" element={<Navigate to="aws" replace />} />
      <Route path="*" element={<Navigate to="aws" replace />} />
    </Routes>
  );
};

export default SystemMonitoring;